// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as trendingnowv2 from './api/trendingnowv2'
import * as pa from './api/pa'
import {displayErrorMessage, displaySuccessMessage, log} from '@insticator/insticator-ui'
import { convertESTtoUTC } from 'utils/date';
import { downloadLink } from '@insticator/insticator-ui/dist/utils/files';


// Trending Now 2.0 


export const approveTrendingNowV2AccessRequest = createAsyncThunk('trendingnowv2/approveTrendingNowV2AccessRequest',
    async (payload, { rejectWithValue }) => {
        const { accountUUID, userEmail } = payload
        try {
          const response = await trendingnowv2.approveTrendingNowV2Access(accountUUID)
          // if logged in non-internal user sent the request
          if(userEmail) {
            store.dispatch(displaySuccessMessage('Your request was sent successfully'))
            return {
              userEmail,
              accountUUID,
              requestStatus: 'PENDING' 
            }
          }
          // if mocked user sent the request
          return response.data
        } catch(err) {
          const error = `There was an issue approving this account`
          store.dispatch(displayErrorMessage(error))
          return null
        }
    }
  );

  
export const fetchTrendingNowV2Config = createAsyncThunk('trendingnowv2/fetchTrendingNowV2Config',
    async payload => {
      const { siteUUID } = payload
      const response = await trendingnowv2.fetchTrendingNowV2Config({ siteUUID })
      return response.data
    }
);

export const fetchTrendingNowV2DisplayConfig = createAsyncThunk('trendingnowv2/fetchTrendingNowV2DisplayConfig',
    async payload => {
      const { siteId } = payload
      const response = await trendingnowv2.fetchTrendingNowV2DisplayConfig({ siteId })
      return response.data
    }
);

export const updateTrendingNowV2Config = createAsyncThunk('trendingnowv2/updateTrendingNowV2Config',
    async (payload, { rejectWithValue }) => {
        const { trendingNowConfig, trendingNowId } = payload
        let requestPayload = {...trendingNowConfig}
        let fallbackImageUrl = trendingNowConfig.advancedConfig ? trendingNowConfig.advancedConfig.fallbackImageUrl : null
        try {
            if(trendingNowConfig.section === 'ADVANCED' && trendingNowConfig.advancedConfig.fallbackImage && trendingNowConfig.advancedConfig.fallbackImageType === 'CUSTOM') {
                const data = new FormData()
                data.append('file', trendingNowConfig.advancedConfig.fallbackImage)
                log(trendingNowConfig.advancedConfig.fallbackImage, data)
                const uploadImageResponse = await trendingnowv2.uploadCustomArticleImageFallback({ trendingNowId, file: data})
                fallbackImageUrl = uploadImageResponse.data 
                log('fallback image url', fallbackImageUrl)
                requestPayload = {advancedConfig: {...requestPayload.advancedConfig, fallbackImageUrl}, section: 'ADVANCED'}
            }

            if(trendingNowConfig.section === 'ADVANCED') {
                const featuredArticleDetails = trendingNowConfig.advancedConfig.featuredArticleDetails

                // check if featured article url is test page and remove #insticator-commenting from url
                const currentFeaturedArticleUrl = trendingNowConfig.advancedConfig.featuredArticleDetails.url || ''
                const featuredArticleUrl = currentFeaturedArticleUrl.replace('#insticator-commenting', '') || ''
                const urlSearchParams = new URLSearchParams(featuredArticleUrl);
                const pageNumber = urlSearchParams.get('page')
                const isInternalTestPage = pageNumber && featuredArticleUrl.includes('core-commenting/preview/article.html')
                const internalPageTitle = isInternalTestPage ? `Article ${pageNumber}` : null

                const advancedConfig = {
                  ...trendingNowConfig.advancedConfig, 
                    featuredArticleDetails: {
                      ...featuredArticleDetails,
                      // convert back the EST date to UTC date
                      startDate: convertESTtoUTC(featuredArticleDetails.startDateEST) || featuredArticleDetails.startDate, 
                      endDate: convertESTtoUTC(featuredArticleDetails.endDateEST) || featuredArticleDetails.endDate,
                      internalPageTitle,
                      url: featuredArticleUrl
                    }
                }
                requestPayload = {advancedConfig: {...requestPayload.advancedConfig, ...advancedConfig, fallbackImageUrl}, section: 'ADVANCED'}
            }
            log('request payload', requestPayload)
            const response = await trendingnowv2.updateTrendingNowV2Config({ trendingNowId: trendingNowId, data: requestPayload })
            store.dispatch(displaySuccessMessage('Trending now config updated.'))
            return response.data
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            // const error = errResponse?.payload || 'There was an issue updating trending now config'
            store.dispatch(displayErrorMessage('There was an issue updating trending now config'))
            return errResponse
        }
    }
);


export const updateTrendingNowV2DisplayConfig = createAsyncThunk('trendingnowv2/updateDisplayConfig',
    async (payload, { rejectWithValue, getState }) => {
        const { displayConfig, siteId, applyForAllProducts = false } = payload

        log(displayConfig)
    
        try {
            const response = await trendingnowv2.updateTrendingNowV2DisplayConfig({ 
                siteId: siteId, 
                    data: {
                        applyForAllProducts,
                        config: displayConfig            
                    } 
            })
            store.dispatch(displaySuccessMessage(applyForAllProducts ? 'Theme has been successfully applied to all products' : 'Display config updated.'))
            log('display config', displayConfig)
            return {...displayConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = applyForAllProducts ? 'There was an issue setting the theme for all products.' : 'There was an issue updating display config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

// Trending Now Analytics

export const fetchPageViewReport = createAsyncThunk(
  'trendingnowv2/fetchPageViewReport',
  async ({ requestData }) => {
      const response = await pa.postTrendingNowPageViewRequest({ requestData });
      return response.data
  }
);

export const fetchTotalClicksReport = createAsyncThunk(
  'trendingnowv2/fetchTotalClicksReport',
  async ({ requestData }) => {
      const response = await pa.postTrendingNowTotalClicksRequest({ requestData });
      return response.data
  }
);

export const fetchTopArticlesReport = createAsyncThunk(
  'trendingnowv2/fetchTopArticlesReport',
  async ({ requestData }) => {
      const response = await pa.postTrendingNowTopArticlesRequest({ requestData });
      return response.data
  }
);

export const fetchTopArticlesExportAll = createAsyncThunk(
  'trendingnowv2/fetchTopArticlesExportAll',
  async (requestData) => {
      const response = await pa.postTrendingNowTopArticlesExportAllRequest(requestData);
      if(response?.data?.exportedFileUrl){
          //download file
          downloadLink(response.data.exportedFileUrl)
      }
      return response.data
  }
);


export const fetchAvgInViewReport = createAsyncThunk(
  'trendingnowv2/fetchAvgInViewReport',
  async ({ requestData }) => {
      const response = await pa.postTrendingNowAvgInViewRequest({ requestData });
      return response.data
  }
);

export const fetchTotalEmbedLoadsReport = createAsyncThunk(
  'trendingnowv2/fetchTotalEmbedLoadsReport',
  async ({ requestData }) => {
      const response = await pa.postTrendingNowTotalEmbedLoadsRequest({ requestData });
      return response.data
  }
);


export const fetchGeneratedPageViews = createAsyncThunk(
  'trendingnowv2/fetchGeneratedPageViews',
  async ({ requestData }) => {
      const response = await pa.postTrendingNowGeneratedPageViewsRequest({ requestData });
      return response.data
  }
);